import type { Divergence } from '../../lib/reconcile.ts';

/** Surfaces source disagreement. A leader conflict is called out plainly and is
 *  never auto-resolved; both sources stay visible. */
export function DivergenceFlag({
  divergence,
  thresholdPct,
}: {
  divergence: Divergence;
  thresholdPct: number;
}) {
  if (!divergence.diverged) return null;
  return (
    <div className="divergence" role="status">
      <p className="divergence__title">
        {divergence.leaderConflict ? 'Sources disagree on the leader' : 'Sources disagree on the margin'}
      </p>
      <p className="divergence__detail">
        {divergence.leaderConflict
          ? 'At least one source shows a different candidate ahead. Both are shown; neither is treated as authoritative.'
          : `Margins differ by up to ${divergence.maxDeltaPct.toFixed(1)} points (flag threshold ${thresholdPct} pts).`}
      </p>
    </div>
  );
}
